const estateFilters = document.querySelector('.estate__filters');

if (estateFilters) {
    const filterButtons = estateFilters.querySelectorAll('.estate__filters__button');
    
    function updateFilterButtonText(filterBlock) {
        const button = filterBlock.querySelector('.estate__filters__button');
        const valuesText = button.querySelector('.values');
        const dropdown = filterBlock.querySelector('.estate__filters__dropdown');
        const checkedCheckboxes = dropdown.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)');
        
        const originalText = valuesText.getAttribute('data-original-text') || valuesText.textContent;
        
        if (!valuesText.hasAttribute('data-original-text')) {
            valuesText.setAttribute('data-original-text', originalText);
        }
        
        if (checkedCheckboxes.length === 0) {
            valuesText.textContent = valuesText.getAttribute('data-original-text');
        } else {
            const selectedValues = Array.from(checkedCheckboxes).map(checkbox => {
                const label = dropdown.querySelector(`label[for="${checkbox.id}"]`);
                return label ? label.textContent.trim() : '';
            }).filter(text => text !== '');
            
            valuesText.textContent = selectedValues.join(', ');
        }
    }
    
    function initializeFilterTexts() {
        const filterBlocks = estateFilters.querySelectorAll('.estate__filters__block');
        filterBlocks.forEach(filterBlock => {
            const button = filterBlock.querySelector('.estate__filters__button');
            const valuesText = button.querySelector('.values');
            
            if (valuesText && !valuesText.hasAttribute('data-original-text')) {
                valuesText.setAttribute('data-original-text', valuesText.textContent);
            }
            
            updateFilterButtonText(filterBlock);
        });
    }
        
    initializeFilterTexts();
    
    filterButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            
            const filterBlock = button.closest('.estate__filters__block');
            
            if (filterBlock.closest('.estate__filters__item-disabled')) {
                return;
            }
            
            const isActive = filterBlock.classList.contains('active');
            closeAllFilters();
            
            if (!isActive) {
                filterBlock.classList.add('active');
            }
        });
    });
    
    const checkboxes = estateFilters.querySelectorAll('input[type="checkbox"]');
    
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.disabled) return;
            
            const filterBlock = this.closest('.estate__filters__block');
            updateFilterButtonText(filterBlock);
        });
    });
    
    const saveButtons = estateFilters.querySelectorAll('.estate__filters__save');
    
    saveButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.stopPropagation();
            const filterBlock = this.closest('.estate__filters__block');
            filterBlock.classList.remove('active');
        });
    });
    
    const clearButtons = estateFilters.querySelectorAll('.estate__filters__clear');

    clearButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.stopPropagation();
            const filterBlock = this.closest('.estate__filters__block');
            const checkboxes = filterBlock.querySelectorAll('input[type="checkbox"]');
            const searchInput = filterBlock.querySelector('.estate__filters__dropdown__search input');
            const noSearchElement = filterBlock.querySelector('.no-seacrh');
            
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            
            if (searchInput) {
                searchInput.value = '';
                
                const dropdown = filterBlock.querySelector('.estate__filters__dropdown');
                const checkboxItems = dropdown.querySelectorAll('.checkbox p');
                
                checkboxItems.forEach(item => {
                    item.style.display = '';
                });
                
                if (noSearchElement) {
                    noSearchElement.classList.remove('active');
                }
                
                searchInput.dispatchEvent(new Event('input'));
            }
            
            updateFilterButtonText(filterBlock);
        });
    });

    const searchInputs = estateFilters.querySelectorAll('.estate__filters__dropdown__search input');
    
    searchInputs.forEach(input => {
        input.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase();
            const dropdown = this.closest('.estate__filters__dropdown');
            const labels = dropdown.querySelectorAll('.checkbox label');
            const noSearchElement = dropdown.querySelector('.no-seacrh');

            let visibleCount = 0;
            labels.forEach(label => {
                const text = label.textContent.toLowerCase();
                const checkboxItem = label.closest('p');
                
                if (text.includes(searchTerm)) {
                    checkboxItem.style.display = '';
                    visibleCount++;
                } else {
                    checkboxItem.style.display = 'none';
                }
            });

            if (noSearchElement) {
                if (visibleCount === 0 && searchTerm !== '') {
                    noSearchElement.classList.add('active');
                } else {
                    noSearchElement.classList.remove('active');
                }
            }
        });
    });
}

const priceBlocks = document.querySelectorAll('.filter__price');
console.log('priceBlocks', priceBlocks)
if (priceBlocks) {
    priceBlocks.forEach(block => {
        const button = block;
        const dropdown = block.querySelector('.filter__price__dropdown');
        const radioInputs = block.querySelectorAll('input[name="filter__price"]');
        console.log('button', button)
        if (!button || !dropdown) return;
        
        const buttonText = button.querySelector('.filter__price__button p');
        const buttonSvgContainer = buttonText ? buttonText.querySelector('svg') : null;
        
        button.addEventListener('click', function(e) {
            e.stopPropagation();
            
            const isActive = button.classList.contains('active');
            closeAllFilters();
            
            if (!isActive) {
                button.classList.add('active');
                dropdown.classList.add('show');
            }
        });
        
        radioInputs.forEach(input => {
            input.addEventListener('change', function() {
                if (this.checked) {
                    const selectedLabel = this.nextElementSibling;
                    const selectedSvg = selectedLabel ? selectedLabel.querySelector('svg') : null;
                    const selectedText = selectedLabel ? selectedLabel.textContent.trim() : 'Price';
                    
                    if (buttonText && selectedSvg) {
                        const newSvg = selectedSvg.cloneNode(true);
                        buttonText.innerHTML = '';
                        buttonText.appendChild(newSvg);
                        buttonText.appendChild(document.createTextNode(' ' + selectedText));
                    }
                    
                    button.classList.remove('active');
                    dropdown.classList.remove('show');
                }
            });
        });
        
        document.addEventListener('click', function(e) {
            if (!block.contains(e.target)) {
                button.classList.remove('active');
                dropdown.classList.remove('show');
            }
        });
        
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                button.classList.remove('active');
                dropdown.classList.remove('show');
            }
        });

        const checkedInput = block.querySelector('input[name="filter__price"]:checked');
        if (checkedInput && buttonText) {
            const selectedLabel = checkedInput.nextElementSibling;
            const selectedSvg = selectedLabel ? selectedLabel.querySelector('svg') : null;
            const selectedText = selectedLabel ? selectedLabel.textContent.trim() : 'Price';
            
            if (selectedSvg) {
                const newSvg = selectedSvg.cloneNode(true);
                buttonText.innerHTML = '';
                buttonText.appendChild(newSvg);
                buttonText.appendChild(document.createTextNode(' ' + selectedText));
            }
        }
    });
}

const currencyBlocks = document.querySelectorAll('.filter__currency');
if (currencyBlocks) {
    currencyBlocks.forEach(block => {
        const button = block;
        const dropdown = block.querySelector('.filter__currency__dropdown');
        const radioInputs = block.querySelectorAll('input[name="filter__currency"]');
        
        if (!button || !dropdown) return;
        
        const buttonText = button.querySelector('.filter__currency__button p');
        
        button.addEventListener('click', function(e) {
            e.stopPropagation();
            
            const isActive = button.classList.contains('active');
            closeAllFilters();
            
            if (!isActive) {
                button.classList.add('active');
                dropdown.classList.add('show');
            }
        });
        
        radioInputs.forEach(input => {
            input.addEventListener('change', function() {
                if (this.checked) {
                    const currencyValue = this.value;
                    const selectedLabel = this.nextElementSibling;
                    const selectedText = selectedLabel ? selectedLabel.textContent.trim() : currencyValue;
                    
                    if (buttonText) {
                        buttonText.textContent = currencyValue;
                    }
                    
                    button.classList.remove('active');
                    dropdown.classList.remove('show');
                    
                    const event = new CustomEvent('currencyChange', {
                        detail: {
                            value: currencyValue,
                            text: selectedText
                        }
                    });
                    block.dispatchEvent(event);
                }
            });
        });
        
        document.addEventListener('click', function(e) {
            if (!block.contains(e.target)) {
                button.classList.remove('active');
                dropdown.classList.remove('show');
            }
        });
        
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeAllFilters();
            }
        });
        
        const checkedInput = block.querySelector('input[name="filter__currency"]:checked');
        if (checkedInput && buttonText) {
            buttonText.textContent = checkedInput.value;
        } else if (buttonText && radioInputs.length > 0) {
            const firstInput = radioInputs[0];
            firstInput.checked = true;
            buttonText.textContent = firstInput.value;
        }
        
        button.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                button.click();
            }
        });
    });
}

function closeAllFilters() {
    const estateFilters = document.querySelector('.estate__filters');
    if (estateFilters) {
        const filterBlocks = estateFilters.querySelectorAll('.estate__filters__block');
        filterBlocks.forEach(block => {
            block.classList.remove('active');
        });
    }
    
    const priceBlocks = document.querySelectorAll('.filter__price');
    if (priceBlocks) {
        priceBlocks.forEach(block => {
            const button = block;
            const dropdown = block.querySelector('.filter__price__dropdown');
            if (button && dropdown) {
                button.classList.remove('active');
                dropdown.classList.remove('show');
            }
        });
    }
    
    const currencyBlocks = document.querySelectorAll('.filter__currency');
    if (currencyBlocks) {
        currencyBlocks.forEach(block => {
            const button = block;
            const dropdown = block.querySelector('.filter__currency__dropdown');
            if (button && dropdown) {
                button.classList.remove('active');
                dropdown.classList.remove('show');
            }
        });
    }
}

document.addEventListener('click', (e) => {
    const estateFilters = document.querySelector('.estate__filters');
    const priceBlocks = document.querySelectorAll('.filter__price__block');
    const currencyBlocks = document.querySelectorAll('.filter__currency__block');
    
    const isInsideEstateFilters = estateFilters && estateFilters.contains(e.target);
    const isInsidePriceFilter = Array.from(priceBlocks).some(block => block.contains(e.target));
    const isInsideCurrencyFilter = Array.from(currencyBlocks).some(block => block.contains(e.target));
    
    if (!isInsideEstateFilters && !isInsidePriceFilter && !isInsideCurrencyFilter) {
        closeAllFilters();
    }
});